
import { Outlet } from "react-router-dom";
import { Box, Stack } from '@mui/material';

import SideMenu from '../components/SideMenu';
import AppNavbar from "../components/AppNavbar";
import AppHeader from "../components/AppHeader";

export default function Account({ props }) {

  return (
    <Box sx={{ display: 'flex' }}>
      <SideMenu />
      <AppNavbar />
      {/* Main content */}
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          width: '100%',
          display: 'flex',
          overflow: 'auto',
          minHeight: '100vh',
          flexDirection: 'column'
        })}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: 'center',
            mx: 3,
            pb: 5,
            flexGrow: 1,
            mt: { xs: 8, md: 0 },
          }}
        >
          <AppHeader />
          <Outlet />
        </Stack>
      </Box>
    </Box>
  );
}